// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2HmK2","header":"ReportDetails_header__JPhZC","title":"ReportDetails_title__2KEpp","left":"ReportDetails_left__2GRI0"};